<template>
    <dialog-modal :show="open">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-white sm:mx-0 sm:h-10 sm:w-10">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
                </svg>
            </div>
        </template>
        <template #title>Testovací prostředí</template>
        <template #content>
            Právě se nacházíte v testovacím prostředí DSchránky.
            <br>
            <b> V tomto prostředí fungují pouze testovací schránky (<a href="https://info.czebox.cz/info/cs/" target="_blank">https://info.czebox.cz/info/cs/</a>). </b>
        </template>
        <template #footer>
            <secondary-button @click.native="open = false" class="ml-2">
                Ok
            </secondary-button>
        </template>
    </dialog-modal>
</template>

<script>
import DialogModal from "../../Jetstream/DialogModal";
import SecondaryButton from "../../Jetstream/SecondaryButton";
export default {
    name: "EnvironmentWarning",
    components: {SecondaryButton, DialogModal},
    props: ['env'],
    data(){
        return {
            open: true
        }
    }
}
</script>

<style scoped>

</style>
